function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { Messaging } from 'oskari-ui/util';
import './request/MapLayerVisibilityRequest';
import './request/MapLayerVisibilityRequestHandler.ol';
import './event/MapLayerVisibilityChangedEvent';
import './request/MapMoveByLayerContentRequest';
import './request/MapMoveByLayerContentRequestHandler';
import olFormatWKT from 'ol/format/WKT';
import { CoverageHelper } from './coveragetool/CoverageHelper';
var WKT_READER = new olFormatWKT();
var AbstractMapModulePlugin = Oskari.clazz.get('Oskari.mapping.mapmodule.plugin.AbstractMapModulePlugin');
var SUPPORTED_DELAY = 2000;
var VISIBILITY_DELAY = 750;

/**
 * @class Oskari.mapframework.bundle.mapmodule.plugin.LayersPlugin
 *
 * This is a plugin to bring more functionality for the mapmodules map
 * implementation. It provides handling for rearranging layer order and
 * controlling layer visibility. Provides information to other bundles if a layer
 * becomes visible/invisible (out of scale/out of content geometry) and request handlers
 * to move map to location/scale based on layer content. Also optimizes openlayers maplayers
 * visibility setting if it detects that content is not in the viewport.
 */
export var LayersPlugin = /*#__PURE__*/function (_AbstractMapModulePlu) {
  function LayersPlugin() {
    var _this;
    _classCallCheck(this, LayersPlugin);
    _this = _callSuper(this, LayersPlugin);
    _this._clazz = 'Oskari.mapframework.bundle.mapmodule.plugin.LayersPlugin';
    _this._name = 'LayersPlugin';
    _this._supportedFormats = {};
    _this._visibilityCheckOrder = 0;
    _this._previousTimer = null;
    _this._supportedTimer = null;
    _this.coverageHelper = new CoverageHelper();
    return _this;
  }
  _inherits(LayersPlugin, _AbstractMapModulePlu);
  return _createClass(LayersPlugin, [{
    key: "_createEventHandlers",
    value: function _createEventHandlers() {
      var _this2 = this;
      return {
        MapMoveStartEvent: function MapMoveStartEvent() {
          // clear out any previous visibility check when user starts to move map
          // not always sent f.ex. when moving with keyboard so do this in
          // AfterMapMoveEvent also
          _this2._visibilityCheckOrder += 1;
          if (_this2._previousTimer) {
            clearTimeout(_this2._previousTimer);
            _this2._previousTimer = null;
          }
        },
        AfterMapMoveEvent: function AfterMapMoveEvent() {
          // visibility checks are cpu intensive so only make them when the map has stopped moving
          _this2._scheduleVisiblityCheck();
        },
        AfterMapLayerAddEvent: function AfterMapLayerAddEvent(event) {
          _this2._afterMapLayerAddEvent(event);
        },
        MapLayerEvent: function MapLayerEvent(event) {
          if (event.getOperation() !== 'add') {
            return;
          }
          _this2._scheduleSupportedCheck();
        }
      };
    }
  }, {
    key: "_createRequestHandlers",
    value: function _createRequestHandlers() {
      var sandbox = this.getSandbox();
      return {
        'MapModulePlugin.MapLayerVisibilityRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.MapLayerVisibilityRequestHandler', sandbox, this),
        'MapModulePlugin.MapMoveByLayerContentRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.MapMoveByLayerContentRequestHandler', sandbox, this)
      };
    }
  }, {
    key: "_afterMapLayerAddEvent",
    value: function _afterMapLayerAddEvent(event) {
      var _event$getMapLayer$ge = event.getMapLayer().getVisibilityInfo(),
        unsupported = _event$getMapLayer$ge.unsupported;
      if (unsupported) {
        Messaging.warn({
          content: unsupported.getDescription(),
          duration: 5
        });
      }
    }

    /**
     * @method handleDescribeLayer
     * @private
     *
     * If layer.getGeometry() is empty, tries to parse layer.getGeometryWKT()
     * and set parsed geometry to the layer
     *
     * @param
     * {Oskari.mapframework.domain.WmsLayer/Oskari.mapframework.domain.WfsLayer/Oskari.mapframework.domain.VectorLayer}
     *            layer layer for which to parse geometry
     *
     */
  }, {
    key: "handleDescribeLayer",
    value: function handleDescribeLayer(layer, info) {
      var coverage = info.coverage;
      // already parsed
      var hasGeometry = layer.getGeometry().length > 0;
      if (!hasGeometry && coverage) {
        var geometry = WKT_READER.readGeometry(coverage);
        if (geometry) {
          layer.setGeometryWKT(coverage);
          layer.setGeometry([geometry]);
          this.coverageHelper.addCoverageTool(layer);
        }
      }
      // set visibility info
      var inScale = this._isInScale(layer);
      var geometryMatch = this.isInGeometry(layer);
      layer.updateVisibilityInfo({
        inScale: inScale,
        geometryMatch: geometryMatch
      });
    }

    /**
     * @method isInGeometry
     * If the given layer has geometry, checks if it is visible in the maps viewport.
     * If layer doesn't have geometry, returns always true since then we can't
     * determine this.
     * @param
     * {Oskari.mapframework.domain.WmsLayer/Oskari.mapframework.domain.WfsLayer/Oskari.mapframework.domain.VectorLayer}
     *            layer layer to check against
     * @return {Boolean} true if geometry is visible or cant determine if it isnt
     */
  }, {
    key: "isInGeometry",
    value: function isInGeometry(layer) {
      var geometries = layer.getGeometry() || [];
      if (geometries.length === 0) {
        return true;
      }
      var viewBounds = this.getMapModule().getCurrentExtent();
      var olExtent = [viewBounds.left, viewBounds.bottom, viewBounds.right, viewBounds.top];
      return geometries[0].intersectsExtent(olExtent);
    }

    /**
     * @method getGeometryCenter
     *
     * @param {ol/geom/Geometry} geometry
     * @return {Object} centroid
     */
  }, {
    key: "getGeometryCenter",
    value: function getGeometryCenter(geometry) {
      if (geometry.getType() === 'Point') {
        var point = geometry.getCoordinates();
        return {
          lon: point[0],
          lat: point[1]
        };
      } else if (geometry.getType() === 'Polygon') {
        var extent = geometry.getExtent();
        return {
          lon: extent[0] + (extent[2] - extent[0]) / 2,
          lat: extent[1] + (extent[3] - extent[1]) / 2
        };
      } else {
        //
      }
    }

    /**
     * @method getGeometryBounds
     *
     * @param {ol/geom/Geometry} geometry
     * @return {Object} like OpenLayers bounds
     */
  }, {
    key: "getGeometryBounds",
    value: function getGeometryBounds(geometry) {
      var extent = geometry.getExtent();
      return {
        left: extent[0],
        bottom: extent[1],
        right: extent[2],
        top: extent[3]
      };
    }

    /**
     * @method _scheduleVisiblityCheck
     * @private
     * Schedules a visibility check on selected layers. After given timeout
     * calls  _checkLayersVisibility()
     */
  }, {
    key: "_scheduleVisiblityCheck",
    value: function _scheduleVisiblityCheck() {
      var me = this;
      if (this._previousTimer) {
        clearTimeout(this._previousTimer);
        this._previousTimer = null;
      }
      this._visibilityCheckOrder++;
      this._previousTimer = setTimeout(function () {
        me._checkLayersVisibility(me._visibilityCheckOrder);
      }, VISIBILITY_DELAY);
    }
  }, {
    key: "_scheduleSupportedCheck",
    value: function _scheduleSupportedCheck() {
      var _this3 = this;
      if (this._supportedTimer) {
        clearTimeout(this._supportedTimer);
        this._supportedTimer = null;
      }
      this._supportedTimer = setTimeout(function () {
        _this3._checkSupportedLayers();
      }, SUPPORTED_DELAY);
    }
  }, {
    key: "_checkSupportedLayers",
    value: function _checkSupportedLayers() {
      var sb = this.getSandbox();
      var layers = sb.getService('Oskari.mapframework.service.MapLayerService').getAllLayers();
      var map = sb.getMap();
      layers.forEach(function (layer) {
        var unsupported = map.getMostSevereUnsupportedLayerReason(layer);
        layer.updateVisibilityInfo({
          unsupported: unsupported
        });
      });
    }

    /**
     * @method _checkLayersVisibility
     * @private
     * Loops through selected layers and notifies other modules about visibility
     * changes
     * @param {Number} orderNumber checks orderNumber against
     * #_visibilityCheckOrder
     *      to see if this is the latest check, if not - does nothing
     * @param {boolean} isRequest triggered by a request
     */
  }, {
    key: "_checkLayersVisibility",
    value: function _checkLayersVisibility(orderNumber, isRequest) {
      var _this4 = this;
      if (orderNumber !== this._visibilityCheckOrder) {
        return;
      }
      this._sandbox.findAllSelectedMapLayers().forEach(function (layer) {
        if (layer.isVisible()) {
          _this4.handleMapLayerVisibility(layer, isRequest);
        }
      });
      this._visibilityCheckScheduled = false;
    }

    /**
     * @method _isInScale
     * @private
     * Checks if the maps scale is in the given maplayers scale range
     * @param
     * {Oskari.mapframework.domain.WmsLayer/Oskari.mapframework.domain.WfsLayer/Oskari.mapframework.domain.VectorLayer}
     *            layer layer to check scale against
     * @return {Boolean} true maplayer is visible in current zoomlevel
     */
  }, {
    key: "_isInScale",
    value: function _isInScale(layer) {
      var scale = this.getMapModule().getMapScale();
      return layer.isInScale(scale);
    }
  }, {
    key: "_isLayerImplVisible",
    value: function _isLayerImplVisible(olLayer) {
      return olLayer.getVisible();
    }
  }, {
    key: "_setLayerImplVisible",
    value: function _setLayerImplVisible(olLayer, visible) {
      olLayer.setVisible(visible);
    }

    /**
     * @method handleMapLayerVisibility
     * Checks layer's visibility (visible, inScale, inGeometry) and sets ol layers' visibilities.
     * notifies bundles about visibility changes by sending MapLayerVisibilityChangedEvent.
     * @param
     * {Oskari.mapframework.domain.WmsLayer/Oskari.mapframework.domain.WfsLayer/Oskari.mapframework.domain.VectorLayer}
     *            layer layer to check against
     * @param {Boolean} isRequest if MapLayerVisibilityRequest, then trigger always change because layer's visibility has changed
    */
  }, {
    key: "handleMapLayerVisibility",
    value: function handleMapLayerVisibility(layer, isRequest) {
      var _this5 = this;
      var visible = layer.isVisible();
      var triggerChange = isRequest === true;

      // check actual values only for visible layer
      var inScale = visible ? this._isInScale(layer) : false;
      var geometryMatch = visible ? this.isInGeometry(layer) : false;

      // setup maplayers visibility (optimization purposes)
      // NOTE: DO NOT CHANGE layer's visibility here
      var olLayers = this.getMapModule().getOLMapLayers(layer.getId()) || [];
      var shouldBeVisible = visible && inScale && geometryMatch;
      olLayers.forEach(function (ol) {
        if (_this5._isLayerImplVisible(ol) !== shouldBeVisible) {
          _this5._setLayerImplVisible(ol, shouldBeVisible);
          triggerChange = true;
        }
      });
      if (triggerChange) {
        layer.updateVisibilityInfo({
          inScale: inScale,
          geometryMatch: geometryMatch
        });
        var event = Oskari.eventBuilder('MapLayerVisibilityChangedEvent')(layer, inScale, geometryMatch);
        this._sandbox.notifyAll(event);
      }
    }
  }]);
}(AbstractMapModulePlugin);